import React from 'react';
interface HistoryMarkerProps {
  label: string;
}
export function HistoryMarker({
  label
}: HistoryMarkerProps) {
  return <div className="flex items-center justify-center py-4" data-id="element-78">
      <div className="h-px bg-gray-200 flex-1" data-id="element-79"></div>
      <span className="px-4 text-xs font-medium text-gray-400 uppercase tracking-wide" data-id="element-80">
        {label}
      </span>
      <div className="h-px bg-gray-200 flex-1" data-id="element-81"></div>
    </div>;
}